import React, { useEffect, useState } from "react"

import s from "./modal.module.css"
import { createPortal } from "react-dom"
import { Button } from "@radix-ui/themes"

type ModalProps = {
  isOpen: boolean
  onClose: () => void
  header?: string
  onOk: () => void
  content: string | JSX.Element
  size?: "default" | "auto" | "xs" | "s" | "m" | "l" | "xl"
  isOkDisabled?: boolean
  okContent?: string
  hideCancelBtn?: boolean
}
export const Modal = ({
  isOpen,
  onClose,
  header,
  onOk,
  content,
  size,
  isOkDisabled,
  okContent,
  hideCancelBtn,
}: ModalProps) => {
  const [open, setOpen] = useState(!!isOpen)
  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen])
  if (!isOpen || !open) return null
  const onCloseModal = () => {
    setOpen(false)
    onClose()
  }
  const onConfirm = () => {
    setOpen(false)
    onOk()
  }

  return createPortal(
    <div
      className={s.modalWrapper}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onCloseModal()
      }}
    >
      <div className={`${s.modal} ${s[size || "auto"]}`}>
        <div className={s.header}>
          <div className={s.title}>{header}</div>
          <div className={s.closeBtn} onClick={onCloseModal}>
            X
          </div>
        </div>
        <div className={s.content}>
          <span>{content}</span>
        </div>
        <div className={s.footer}>
          {!hideCancelBtn && <Button onClick={onCloseModal}>Отмена</Button>}
          <Button onClick={onConfirm} disabled={isOkDisabled}>
            {okContent || "ОК"}
          </Button>
        </div>
      </div>
    </div>,
    document.querySelector("main.App") || document.body,
  )
}
